import React from 'react'

export default function Column(props) {
    return (
        <div className={` p-col ${props.extra ? props.extra : ""}  ${props.col ? `p-col-${props.col}` : ""}  ${props.md ? `p-md-${props.md}` : ""}  ${props.sm ? `p-sm-${props.sm}` : ""}  ${props.lg ? `p-lg-${props.lg}` : ""} `} >
            {props.children}
        </div >
    )
}
